<template>
  <md-dialog
    :md-active.sync="isOpen"
    :md-backdrop="true"
    :md-fullscreen="true"
  >
    <md-dialog-title>Switch Businesses</md-dialog-title>

      <md-dialog-content v-if="businessLoading"  style="margin: 0 24px 24px">
      Loading options...
    </md-dialog-content>

    <md-dialog-content v-else-if="businesses.length">
      <md-list>
        <md-list-item
          :key="business.id"
          v-for="business in businesses"
          class="hover"
        >
          <!-- <md-radio v-model="activeBusiness" :value="business.id" /> -->
          <md-radio :value="business.id" v-on:change="onBusinessChange" />
          <span class="md-list-item-text">{{ business.name }}</span>
        </md-list-item>
      </md-list>
    </md-dialog-content>

    <md-dialog-content v-else style="margin: 0 24px 24px">
      No data at the moment
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="onClose"
        >Close</md-button
      >
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  props: {
    businesses: Array,
    businessLoading: Boolean,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    onOpen() {
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },
    onBusinessChange(selected) {
      this.$emit('onBusinessChange', selected);
    },
  },
};
</script>
